export default {
  namespaced: true,
  state: {
    selectedSection: 'registrations',
    selectedTab: 'events',
    filters: {
      selectedEntity: null,
      entityId: null,
    },
  },
  mutations: {
    setSelectedSection(state, payload) {
      state.selectedSection = payload;
    },
    setSelectedTab(state, payload) {
      state.selectedTab = payload;
    },
    setSelectedEntity(state, payload) {
      state.filters.selectedEntity = payload;
    },
    setEntityId(state, payload) {
      state.filters.entityId = payload;
    },
  },
  actions: {
    setSelectedSection({ commit }, payload) {
      commit('setSelectedSection', payload);
    },
    setSelectedTab({ commit }, payload) {
      commit('setSelectedTab', payload);
    },
    setSelectedEntity({ commit }, payload) {
      commit('setSelectedEntity', payload);
    },
    setEntityId({ commit }, payload) {
      commit('setEntityId', payload);
    },
  },
  getters: {
    selectedSection: (state) => state.selectedSection,
    selectedTab: (state) => state.selectedTab,
    selectedEntity: (state) => state.filters.selectedEntity,
    entityId: (state) => state.filters.entityId,
  },
};
